import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterByGroup } from 'src/app/components/insoles-prescription/filterByGroup.pipe';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TablerIconsModule } from 'angular-tabler-icons';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion'
import { RadioButtonModule } from 'primeng/radiobutton'
import { DropdownModule } from 'primeng/dropdown'
import { NgSelectModule } from '@ng-select/ng-select';
import { TableModule } from 'primeng/table'
import { InputTextModule } from 'primeng/inputtext'
import { InputSwitchModule } from 'primeng/inputswitch';
import { ProgressBarModule } from 'primeng/progressbar';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgApexchartsModule } from 'ng-apexcharts';
import { OverlayPanelModule } from 'primeng/overlaypanel'
import { TooltipModule } from 'primeng/tooltip';
import { RouterModule } from '@angular/router';
import { FileUploadModule } from 'primeng/fileupload';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { FilterByPressureTypePipe } from 'src/app/components/order-details/filterByPressureType.pipe';
import { FilterByImageTypePipe } from 'src/app/components/order-details/filterByImageType.pipe';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SkeletonModule } from 'primeng/skeleton';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { QRCodeModule } from 'angularx-qrcode';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { FormatComponentTypePipe } from 'src/app/components/insoles-prescription/formatComponentType.pipe';
import { ChipsModule } from 'primeng/chips';
import { StepperModule } from 'primeng/stepper';
import { HasPermissionPipe } from 'src/app/pages/dashboard/has-permission.pipe';
import { IsNumberPipe } from 'src/app/components/prescription-pdf-view/is-number-pipe';

@NgModule({
    declarations: [FilterByGroup, FilterByPressureTypePipe, FilterByImageTypePipe, FormatComponentTypePipe, HasPermissionPipe, IsNumberPipe],
    imports: [CommonModule],
    exports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        FormsModule,
        TablerIconsModule,
        TranslateModule,
        DialogModule,
        ButtonModule,
        FilterByGroup,
        AccordionModule,
        RadioButtonModule,
        DropdownModule,
        NgSelectModule,
        TableModule,
        InputTextModule,
        InputSwitchModule,
        ProgressBarModule,
        MatPaginatorModule,
        MatTooltipModule,
        MultiSelectModule,
        MatChipsModule,
        MatFormFieldModule,
        MatInputModule,
        NgApexchartsModule,
        OverlayPanelModule,
        TooltipModule,
        RouterModule,
        FileUploadModule,
        NgxSliderModule,
        FilterByPressureTypePipe,
        FilterByImageTypePipe,
        NgxSkeletonLoaderModule,
        SkeletonModule,
        CardModule,
        ToastModule,
        QRCodeModule,
        PdfViewerModule,
        FormatComponentTypePipe,
        ChipsModule,
        StepperModule,
        HasPermissionPipe,
        IsNumberPipe
    ]
})
export class SharedModule { }